/**
 * wagbappro.id 法律页印尼语内容（文案 1:1 还原需求文档）
 */

export const legalPages = {
  disclaimer: {
    slug: 'disclaimer',
    intro: 'Selamat datang di WAGBAPPRO.ID.',
    introAfter:
      'Semua informasi yang tersedia di situs ini disediakan hanya untuk tujuan informasi dan edukasi. Kami berusaha menyajikan konten yang akurat dan selalu diperbarui, namun kami tidak memberikan jaminan mengenai kelengkapan, keakuratan, atau keandalan informasi tersebut.',
    sections: [
      {
        title: 'Informasi Umum',
        paragraphs: [
          {
            textBefore: '',
            linkText: 'WAGBAPPRO.ID',
            linkTo: '/',
            textAfter:
              ' merupakan situs yang menyediakan artikel, panduan, ulasan, dan informasi mengenai WA GB APK serta berbagai versi yang tersedia untuk perangkat Android.',
          },
          'Seluruh keputusan untuk mengunduh, memasang, atau menggunakan aplikasi merupakan tanggung jawab pengguna sepenuhnya.',
        ],
      },
      {
        title: 'Hubungan dengan WhatsApp',
        paragraphs: [
          'WAGBAPPRO.ID bukan bagian dari, tidak berafiliasi dengan, dan tidak didukung oleh WhatsApp LLC maupun Meta Platforms, Inc.',
          'Nama "WhatsApp" dan seluruh merek dagang terkait adalah milik pemilik resminya.',
        ],
      },
      {
        title: 'File APK dan Konten Pihak Ketiga',
        paragraphs: [
          'Kami tidak mengembangkan aplikasi WA GB maupun memodifikasi aplikasi resmi WhatsApp.',
          'Apabila tersedia tautan unduhan, tautan tersebut hanya bertujuan memudahkan pengguna menemukan sumber file yang tersedia secara publik.',
        ],
      },
      {
        title: 'Risiko Penggunaan',
        listIntro: 'Penggunaan aplikasi modifikasi dapat menimbulkan risiko seperti:',
        list: [
          'Temporary ban atau permanent ban akun',
          'Kehilangan data atau chat',
          'Ketidakcocokan dengan perangkat tertentu',
        ],
        paragraphsAfter: [
          'Pengguna disarankan untuk selalu melakukan backup data sebelum melakukan instalasi atau pembaruan aplikasi.',
        ],
      },
      {
        title: 'Perubahan Disclaimer',
        paragraphs: [
          'Isi halaman ini dapat diperbarui sewaktu-waktu tanpa pemberitahuan sebelumnya sesuai dengan perkembangan layanan dan kebijakan situs.',
        ],
      },
    ],
  },
  dmca: {
    slug: 'dmca',
    intro: {
      textBefore: '',
      linkText: 'WAGBAPPRO.ID',
      linkTo: '/',
      textAfter:
        ' menghormati hak kekayaan intelektual dan berkomitmen untuk mematuhi ketentuan Digital Millennium Copyright Act (DMCA).',
    },
    sections: [
      {
        title: 'Penghormatan Hak Cipta',
        paragraphs: [
          'Kami berusaha memastikan bahwa seluruh konten yang dipublikasikan tidak melanggar hak cipta pihak lain.',
          'Jika Anda adalah pemilik hak cipta atau perwakilan resmi yang menemukan materi yang dianggap melanggar hak Anda, silakan kirimkan pemberitahuan resmi kepada kami.',
        ],
      },
      {
        title: 'Informasi yang Harus Disertakan',
        listIntro: 'Permintaan DMCA sebaiknya memuat informasi berikut:',
        list: [
          'Nama dan identitas pemilik hak cipta',
          'Deskripsi karya yang dilindungi',
          'URL halaman yang dianggap melanggar',
          'Informasi kontak yang valid',
          'Pernyataan bahwa laporan dibuat dengan itikad baik',
        ],
      },
      {
        title: 'Proses Peninjauan',
        listIntro: 'Setelah menerima laporan yang valid, kami akan:',
        list: [
          'Meninjau permintaan',
          'Menghapus atau membatasi akses terhadap konten jika diperlukan',
          'Menghubungi pihak terkait apabila dibutuhkan klarifikasi',
        ],
      },
      {
        title: 'Konten Pihak Ketiga',
        paragraphs: [
          'WAGBAPPRO.ID dapat menampilkan tautan menuju situs lain. Kami tidak bertanggung jawab atas konten, file, maupun layanan yang disediakan oleh situs pihak ketiga tersebut.',
        ],
      },
    ],
  },
  privacy: {
    slug: 'privacy',
    intro: {
      textBefore: 'Privasi pengunjung merupakan prioritas bagi ',
      linkText: 'WAGBAPPRO.ID',
      linkTo: '/',
      textAfter: '.',
    },
    introAfter:
      'Halaman ini menjelaskan bagaimana informasi dikumpulkan dan digunakan saat Anda mengakses situs kami.',
    sections: [
      {
        title: 'Informasi yang Dikumpulkan',
        listIntro: 'Kami dapat mengumpulkan informasi non-pribadi seperti:',
        list: [
          'Jenis perangkat',
          'Browser yang digunakan',
          'Halaman yang dikunjungi',
          'Waktu akses',
          'Alamat IP yang dianonimkan sesuai kebijakan yang berlaku',
        ],
        paragraphsAfter: ['Kami tidak meminta informasi pribadi yang sensitif melalui situs ini.'],
      },
      {
        title: 'Cookies',
        listIntro: 'WAGBAPPRO.ID menggunakan cookies untuk:',
        list: [
          'Mengingat preferensi pengguna',
          'Meningkatkan pengalaman penggunaan',
          'Menganalisis performa situs',
        ],
        paragraphsAfter: [
          'Pengguna dapat menonaktifkan cookies melalui pengaturan browser masing-masing.',
        ],
      },
      {
        title: 'Layanan Pihak Ketiga',
        paragraphs: [
          'Kami dapat menggunakan layanan analitik dan periklanan pihak ketiga yang memiliki kebijakan privasi sendiri.',
          'Layanan tersebut dapat menggunakan cookies atau teknologi serupa untuk menyajikan pengalaman yang lebih relevan.',
        ],
      },
      {
        title: 'Keamanan Data',
        paragraphs: [
          'Kami berupaya menjaga keamanan informasi yang dikumpulkan, namun tidak ada metode transmisi data melalui internet yang dapat dijamin sepenuhnya aman.',
        ],
      },
      {
        title: 'Perubahan Kebijakan',
        paragraphs: [
          'Privacy Policy ini dapat diperbarui sewaktu-waktu. Versi terbaru akan selalu tersedia di halaman ini dengan tanggal pembaruan yang diperbarui.',
          'Dengan menggunakan WAGBAPPRO.ID, Anda dianggap telah memahami dan menyetujui kebijakan privasi yang berlaku.',
        ],
      },
    ],
  },
};

export function getLegalPage(slug) {
  return legalPages[slug] || null;
}
